

















import { Component, Prop } from "vue-property-decorator";
import languages from "@/assets/metadata/metadata.lang.min.json";

// Mixins
import { WidgetMixin } from "./mixins";

@Component
export default class WLanguage extends WidgetMixin {
  // TODO: create an alignment mixin
  // Copied from the text mixin
  @Prop({
    type: String,
    default: "left",
    validator: (value) => ["left", "center", "right"].includes(value),
  })
  align!: string;

  get currentLocale() {
    return this.$route.params.locale || "en";
  }

  get computedLocales() {
    const locales = this.$store.getters["form/locales"] as string[];
    return locales.map((locale) => ({
      value: locale,
      text: (languages as any)[locale],
      to: {
        ...this.$route,
        params: { ...this.$route.params, locale },
      },
    }));
  }

  get computedStyles() {
    return {
      textAlign: this.align,
    };
  }
}
